export const capitalizeFirstLetter = (value: string): string => {
  return value.charAt(0).toUpperCase() + value.slice(1);
};

export const lowercaseFirstLetter = (value: string): string => {
  return value.charAt(0).toLowerCase() + value.slice(1);
};
